import type { IUserDetailsRequest } from '../../types/IRequestTypes';
import ApiUrl from '../services/APIUrl';
import { appSettings } from '../settings';
import AxiosClient from './AxiosClient';
import { handleSuccess } from './HttpUtil';

export const UserApi = {
  // This api call will returns the logged in user details from the DB
  getLoggedInUserDetails: (action: IUserDetailsRequest) => {
    return AxiosClient.get(ApiUrl.ReadUserDetails, {
      baseURL: appSettings.DisEndpoint,
      headers: { Authorization: `Bearer ${action.token}` },
    })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return { error: err };
      });
  },
};
